(() => {
  'use strict';
  const money = new Intl.NumberFormat('de-DE', {style:'currency',currency:(window.Shopify?.currency?.active || 'EUR')});
  const element = (tag,cls,txt) => {const n=document.createElement(tag);if(cls)n.className=cls;if(txt!==undefined)n.textContent=txt;return n;};
  function setup(form) {
    if(form.dataset.liveSearchReady)return;
    const input=form.querySelector('input[type="search"]');
    const box=form.querySelector('[data-ds24-search-results]');
    if(!input||!box)return;
    form.dataset.liveSearchReady='1';
    let timer,controller,token=0,index=-1;
    function hide(){box.hidden=true;index=-1;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');}
    function show(){box.hidden=false;index=-1;input.setAttribute('aria-expanded','true');input.removeAttribute('aria-activedescendant');}
    function searchUrl(q){const u=new URL(form.action);u.searchParams.set('q',q);u.searchParams.set('type','product');u.searchParams.set('options[prefix]','last');return u.href;}
    function render(products,q){
      box.replaceChildren();
      box.append(element('div','ds24-live-search__heading',products.length?'Passende Produkte':'Keine passenden Produkte gefunden'));
      const list=element('div','ds24-live-search__list');
      products.forEach(p=>{
        if(!p||!p.title||!p.url)return;
        let u;try{u=new URL(p.url,location.origin);}catch(e){return;}
        if(u.origin!==location.origin)return;
        const a=element('a','ds24-live-search__product');
        a.href=u.href;a.id=box.id+'-p'+list.children.length;a.setAttribute('role','option');a.setAttribute('aria-selected','false');
        const image=p.featured_image?.url||p.image;
        if(image){const img=element('img','ds24-live-search__img');img.src=image;img.alt=p.featured_image?.alt||p.title;img.loading='lazy';img.decoding='async';a.append(img);}
        else a.append(element('span','ds24-live-search__img ds24-live-search__placeholder','DS24'));
        const details=element('span','ds24-live-search__details');
        details.append(element('span','ds24-live-search__title',p.title));
        const price=Number(p.price);
        if(Number.isFinite(price))details.append(element('span','ds24-live-search__price',money.format(price)));
        if(p.available===false)details.append(element('span','ds24-live-search__out','Derzeit nicht lieferbar'));
        a.append(details);list.append(a);
      });
      if(list.children.length)box.append(list);
      const all=element('a','ds24-live-search__all','Alle Suchergebnisse anzeigen');all.href=searchUrl(q);box.append(all);
      show();
    }
    async function run(q,runToken){
      controller=new AbortController();
      try{
        const root=window.Shopify?.routes?.root||new URL(form.action).pathname.replace(/search\/?$/,'');
        const u=new URL('search/suggest.json',new URL(root,location.origin));
        u.searchParams.set('q',q);u.searchParams.set('resources[type]','product');
        u.searchParams.set('resources[limit]','8');u.searchParams.set('resources[options][unavailable_products]','last');
        const res=await fetch(u.href,{signal:controller.signal,credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!res.ok)throw Error('Shopify search unavailable');
        const json=await res.json();
        if(runToken!==token||input.value.trim()!==q)return;
        render(json?.resources?.results?.products||[],q);
      }catch(e){if(e.name!=='AbortError'&&runToken===token)hide();}
    }
    function changed(){
      clearTimeout(timer);controller?.abort();
      const runToken=++token,q=input.value.trim();
      if(!q){box.replaceChildren();hide();return;}
      timer=setTimeout(()=>run(q,runToken),180);
    }
    input.addEventListener('input',changed);
    input.addEventListener('focus',()=>{if(input.value.trim())changed();});
    input.addEventListener('keydown',e=>{
      if(e.key==='Escape'){hide();return;}
      if(box.hidden)return;
      const options=Array.from(box.querySelectorAll('a[role="option"]'));
      if(!options.length)return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault();
        index=e.key==='ArrowDown'?(index+1)%options.length:(index-1+options.length)%options.length;
        options.forEach((el,i)=>el.setAttribute('aria-selected',String(i===index)));
        input.setAttribute('aria-activedescendant',options[index].id);
        options[index].scrollIntoView({block:'nearest'});
      }else if(e.key==='Enter'&&index>=0){e.preventDefault();options[index].click();}
    });
    document.addEventListener('pointerdown',e=>{if(!form.contains(e.target))hide();});
    form.addEventListener('submit',()=>{clearTimeout(timer);controller?.abort();});
  }
  const init=root=>root.querySelectorAll('.ds24-new-header__search[data-ds24-live-search]').forEach(setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();